import { Link } from 'react-router-dom';
import { site } from '@/mocks/manhwa';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{site.brand}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-background-300">
              {site.name} 是一份持续更新的韩漫推荐书单。从高分人气到冷门宝藏，按题材为你整理必看佳作，帮你快速找到合口味的作品，追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3 text-background-200">
              <a href="https://x.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="X" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-900 hover:bg-primary-500 transition-colors"><i className="ri-twitter-x-fill" /></a>
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-900 hover:bg-primary-500 transition-colors"><i className="ri-weibo-fill" /></a>
              <a href="https://www.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-900 hover:bg-primary-500 transition-colors"><i className="ri-bilibili-fill" /></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-base font-semibold text-background-50">书单栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li><a href="/#featured" className="hover:text-background-50 transition-colors">精选必看</a></li>
              <li><a href="/#trending" className="hover:text-background-50 transition-colors">高分人气榜</a></li>
              <li><a href="/#genres" className="hover:text-background-50 transition-colors">题材书单</a></li>
              <li><a href="/#gems" className="hover:text-background-50 transition-colors">冷门宝藏</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-base font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li><Link to="/" className="hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><a href="/#faq" className="hover:text-background-50 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50">联系交流</h4>
            <p className="mt-4 text-sm text-background-300">有喜欢的韩漫想推荐给我们，或想加入书单讨论？欢迎来信。</p>
            <a href={`mailto:${site.email}`} className="mt-3 inline-flex items-center gap-2 text-sm text-primary-300 hover:text-accent-300 transition-colors">
              <i className="ri-mail-line" /> {site.email}
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} {site.brand} · 好看的韩漫推荐书单 · 追更不迷路</p>
          <p>本网站内容仅供阅读参考，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}